import { Modale } from '../ui/Modale';
import { LecteurVideo } from '../lecteur/LecteurVideo';

/**
 * Lecture d'un replay dans une fenêtre, avec le lecteur de la plateforme
 * (vitesse, plein écran). La vidéo est servie par une route gardée, par
 * plages : le lecteur avance sans tout télécharger, et l'ouverture est tracée
 * côté serveur.
 */
export function LecteurReplay({
  titre,
  sousTitre,
  source,
  onFermer,
}: {
  titre: string;
  sousTitre?: string;
  source: string | null;
  onFermer: () => void;
}): JSX.Element {
  return (
    <Modale
      titre={titre}
      {...(sousTitre ? { sousTitre } : {})}
      ouverte={source !== null}
      onFermer={onFermer}
      largeur="max-w-5xl"
    >
      {source && <LecteurVideo key={source} source={source} titre={titre} autoPlay />}
    </Modale>
  );
}
